export const COMPLETED_STATUS = 'completed';
export const LOCKED_STATUS = 'locked';
export const STARTED_STATUS = 'started';
export const UNSTARTED_STATUS = 'unstarted';
export const REPLAY_STATUS = 'replay'; // Not a backend enumeration, created for front-end use only
